import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MenuProvider } from './contexts/MenuContext';
import './App.css';
import AppRoutes from './Routes';

import { SyncProvider } from './contexts/SyncContext';


function App() {
  return (
    <Router>
      <MenuProvider>
        <SyncProvider>
          <AppRoutes />

        </SyncProvider>
      </MenuProvider>
    </Router>
  );
}

export default App;
